module.exports = {"140622100":"金城镇","140622101":"南河种镇","140622102":"下社镇","140622200":"镇子梁乡","140622201":"义井乡","140622202":"藏寨乡","140622203":"大黄巍乡","140622204":"杏寨乡","140622205":"下马峪乡","140622206":"南泉乡","140622207":"大临河乡","140622208":"白马石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140622.json
// module id = 317
// module chunks = 0